/* tslint:disable */
/* eslint-disable */
import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { AddImageRateToNoteReplyCommand } from '../../models/add-image-rate-to-note-reply-command';
import { AddImageRateToNoteReplyCommandResult } from '../../models/add-image-rate-to-note-reply-command-result';

export interface ApiKpiReportsAddImageRateToReplyNotePost$Params {
      body?: AddImageRateToNoteReplyCommand
}

export function apiKpiReportsAddImageRateToReplyNotePost(http: HttpClient, rootUrl: string, params?: ApiKpiReportsAddImageRateToReplyNotePost$Params, context?: HttpContext): Observable<StrictHttpResponse<AddImageRateToNoteReplyCommandResult>> {
  const rb = new RequestBuilder(rootUrl, apiKpiReportsAddImageRateToReplyNotePost.PATH, 'post');
  if (params) {
    rb.body(params.body, 'application/*+json');
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'text/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<AddImageRateToNoteReplyCommandResult>;
    })
  );
}

apiKpiReportsAddImageRateToReplyNotePost.PATH = '/api/KPIReports/AddImageRateToReplyNote';
